import { render, staticRenderFns } from "./SaleList.vue?vue&type=template&id=0124c928"
import script from "./SaleList.vue?vue&type=script&lang=js"
export * from "./SaleList.vue?vue&type=script&lang=js"
import style0 from "./SaleList.vue?vue&type=style&index=0&id=0124c928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports